<script>
import ObjectList from './object'

export default {
    name: 'SystemObject',
    components: {
        ObjectList,
    },
    render() {
        return <ObjectList />
    },
}
</script>
